import { BookMarkerIcon } from './BookMarkerIcon';

/**
 * author: Colton Wiscombe
 * id D5DCE615-BCFA-4922-8F95-5CEA756FD378
 * name book-marker
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-marker.svg
 * tags
 * - Navigation 
 */
export const BookLocationIcon = BookMarkerIcon;
export default BookLocationIcon